import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CompanyModel } from 'Pages/company'
import { Callback } from 'Types/utilTypes'

export namespace PartnerAddressesNS {
	export type GetPartnerAddresses = PayloadAction<{
		partner_id?: number
		callback?: Callback
		errorCallback?: Callback
	}>
	export type CreatePartnerAddresses = PayloadAction<{
		data: CompanyModel
		callback: Callback
		errorCallback?: Callback
	}>
	export type UpdatePartnerAddresses = PayloadAction<{
		data: CompanyModel
		callback: Callback
		errorCallback?: Callback
	}>
	export type DeletePartnerAddresses = PayloadAction<{
		id: number
		partner_id: number
		callback: Callback
		errorCallback?: Callback
	}>
}

export const partnerAddressesSlice = createSlice({
	name: 'partnerAddresses',
	initialState: {},
	reducers: {
		getPartnerAddresses: (state, action: PartnerAddressesNS.GetPartnerAddresses) => {},
		updatePartnerAddresses: (state, action: PartnerAddressesNS.UpdatePartnerAddresses) => {},
		deletePartnerAddresses: (state, action: PartnerAddressesNS.DeletePartnerAddresses) => {},
		createPartnerAddresses: (state, action: PartnerAddressesNS.CreatePartnerAddresses) => {},
	},
})
